<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosyamalzeme from "@/models/satdosyamalzeme";
import forminput from "../formcomponet/forminput.vue";
import formcombobox from "../formcomponet/formcombobox.vue";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import yenimalzeme from "../omalzeme/addedit.vue";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [apibtoast, apigeneric, satdosyamalzeme],
  props: ["Id", "AddEdit", "satdosyaId", "getkontrol"],
  data() {
    return {
      FormData: {},
      TableData: {},
      disable: false,
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      omalzemeData: {
        Barkod: "",
        Karekod: "",
        Adi: "",
        Olcubirimi: "",
        Kayittarihi: "",
        Deleted: false,
      },
      MalzemeGruplari: [],
      FormDataMalzeme: {
        Grupid: null
      }
    };
  },
  components: {
    Loader,
    forminput,
    formcombobox,
    Treeselect,
    yenimalzeme


  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.FormData.Dosyaid = this.satdosyaId;
      if (this.AddEdit == 'Edit') {
        this.ActionsSingleGet({
          Service: "omalzeme",
          Id: this.FormData.Malzemeid,
        }).then((res) => {
          this.FormDataMalzeme.Grupid = res.Data.Grupid;
          this.malzemeleri_yukle(this.FormDataMalzeme.Grupid)

        });

      }
      this.Get();
    },
    getkontrol() {
      this.Get();
    }


  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.MalzemeGruplari = [];
    this.ActionsGet({ "Service": "OMalzemeGrup", "Page": Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.MalzemeGruplari.push({ Id: res.Data[i].Id, Value: res.Data[i].Adi })
      }
    });
  },
  methods: {
    onSubmit() {
      this.FormData.Dosyaid = this.satdosyaId;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("satdosyamalzeme", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              let BellekSirano = this.FormData.Sirano
              let Bellek = JSON.stringify(this.satdosyamalzemeData)
              this.FormData = JSON.parse(Bellek)
              this.FormData.Sirano = parseInt(BellekSirano) + 1
              //this.$bvModal.hide("satdosyamalzeme"); 

            }
          });
        } else {
          this.Update("satdosyamalzeme", this.FormData).then((res) => {
            if (res) {

              this.$emit("TableUpdate");
              //this.$bvModal.hide("satdosyamalzeme");


            }
          });
        }
      }
    },
    malzemeleri_yukle(olcuBirimi) {
      if (this.AddEdit == "Add") {
        this.disable = false;
        this.ActionsFilterGet({
          Service: "SatDosyaMalzeme",
          Page: this.Page,
          Filter: "&Dosyaid=" + this.satdosyaId,
        }).then((res) => {
          console.log(res.Data);
          let Page = {
            PageNumber: "1",
            PageSize: "9999"
          }
          this.FormDataType.Malzemeid.ComboDataArray = []
          this.ActionsFilterGet({ Service: "OMalzeme", Page: Page, Filter: "&Grupid=" + olcuBirimi }).then((resMalzeme) => {
            for (var i = 0; i < resMalzeme.Data.length; i++) {
              var Kontrol = false
              let aciklama = "";
              for (var SatirMalzeme in res.Data) {
                if (resMalzeme.Data[i].Id == res.Data[SatirMalzeme].Malzemeid) { Kontrol = true }
              }
              if (Kontrol == false) {
                if (resMalzeme.Data[i].Aciklama != "" && resMalzeme.Data[i].Aciklama != null) {
                  aciklama = " (" + resMalzeme.Data[i].Aciklama + ")";
                }
                this.FormDataType.Malzemeid.ComboDataArray.push({ id: resMalzeme.Data[i].Id, label: resMalzeme.Data[i].Adi + aciklama, Olcubirimi: resMalzeme.Data[i].Olcubirimi })
              }
            }
          });
        });
      } else {
        this.disable = true;
        let Page = {
          PageNumber: "1",
          PageSize: "9999"
        }
        this.FormDataType.Malzemeid.ComboDataArray = []
        this.ActionsGet({ Service: "OMalzeme", Page: Page }).then((resMalzeme) => {
          let aciklama = "";
          for (var i = 0; i < resMalzeme.Data.length; i++) {
            if (resMalzeme.Data[i].Aciklama != "" && resMalzeme.Data[i].Aciklama != null) {
              aciklama = " (" + resMalzeme.Data[i].Aciklama + ")";
            }
            this.FormDataType.Malzemeid.ComboDataArray.push({ id: resMalzeme.Data[i].Id, label: resMalzeme.Data[i].Adi + aciklama, Olcubirimi: resMalzeme.Data[i].Olcubirimi })
          }
        });
      }
    },
    Get() { },
    OlcubirimiGetir() {

      for (var i = 0; this.FormDataType.Malzemeid.ComboDataArray.length; i++) {

        if (this.FormData.Malzemeid == this.FormDataType.Malzemeid.ComboDataArray[i].id)

          this.FormData.Olcubirimi = this.FormDataType.Malzemeid.ComboDataArray[i].Olcubirimi;

      }




    },

    loadOptions({ action, callback }) {
      this.options = [];
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

          this.options = this.OMalzemeListesi;

          callback(null, this.options)
        })
      }
    },


    MalzemeYukle(veri) {
      let Page = {
        PageNumber: "1",
        PageSize: "100",
      };
      this.ActionsFilterGet({
        Service: "SatDosyaMalzeme",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId,
      }).then((SatDosyaMalzeme) => {

        if (SatDosyaMalzeme) {
          if (veri.length >= 3) {
            this.OMalzemeListesi = [];
            let Filter = "&Adi=" + veri;
            var aciklama = ""
            this.ActionsFilterGet({
              Service: "OMalzeme",
              Page: Page,
              Filter: Filter,
            }).then((res) => {
              this.ComboboxMalzeme = res.Data;
              for (var i = 0; i < Object.keys(this.ComboboxMalzeme).length; i++) {

                if (this.ComboboxMalzeme[i].Aciklama != "" && this.ComboboxMalzeme[i].Aciklama != null) {
                  aciklama = " (" + this.ComboboxMalzeme[i].Aciklama + ")";
                }
                var Kontrol = false

                for (var SatirMalzeme in SatDosyaMalzeme.Data) {
                  if (this.ComboboxMalzeme[i].Id == SatDosyaMalzeme.Data[SatirMalzeme].Malzemeid) { Kontrol = true }
                }
                if (!Kontrol) {
                  this.OMalzemeListesi.push({ id: this.ComboboxMalzeme[i].Id, label: this.ComboboxMalzeme[i].Adi + aciklama, Olcubirimi: this.ComboboxMalzeme[i].Olcubirimi })
                }
              }

            });

          }
        }
      })
    },

  },
};
</script>
<template>
  <Loader>
    <b-modal id="satdosyamalzeme" size="lg" :title="
      this.AddEdit == 'Edit'
        ? $t('satdosyamalzeme.MalzemeEkle.FormTitleEdit')
        : $t('satdosyamalzeme.MalzemeEkle.FormTitleAdd')
    " title-class="font-18" hide-footer>
      <Form @submit.prevent="onSubmit">


        <forminput style="width:250px" :FormDataType="FormDataType.Sirano" :Value="FormData.Sirano"
          :v="$v.FormData.Sirano" @input="FormData.Sirano = $event" />
        <div class="col-md-11" v-if="0">
          <formcombobox v-if="!Taleptoplamasontarih ? true : false" :FormDataType='{
            FieldName: "Grupid",
            Field: "combobox",
            FieldTitle: this.$t("sattalep.AddEdit.Grupid"),
            ComboDataArray: MalzemeGruplari,
          }' :Value="FormDataMalzeme.Grupid" v=""
            @input="malzemeleri_yukle(FormDataMalzeme.Grupid = $event)"
            :Disabled="this.AddEdit == 'Edit' ? true : false" />
        </div>


        <b-form-group class="mb-3" id="treeselect" :label="FormDataType.Malzemeid.FieldTitle" label-for="text">
          <div class="row">
            <div class="col-md-11">



              <treeselect @search-change="MalzemeYukle($event)" :async="true" :load-options="loadOptions"
                :cacheOptions="false" searchPromptText="Aramak için yazın..." :multiple="false"
                :options="FormDataType.Malzemeid.ComboDataArray" :disabled="disable" placeholder="Seçiniz..."
                v-model="FormData.Malzemeid" :class="{ 'is-invalid': $v.FormData.Malzemeid.$error }"
                @input="OlcubirimiGetir()" />
              <treeselect-value :value="FormData.Malzemeid" />

              <div v-if="$v.FormData.Malzemeid.$error" class="invalid-feedback">
                <span v-if="$v.FormData.Malzemeid.required == false">{{ $t("ValidationMessage.required") }}</span>
              </div>
            </div>
            <div class="col-md-1">

              <i class="fas fa-plus" v-b-modal.omalzeme @click="(DataUpdate = omalzemeData)"></i>
            </div>
          </div>
        </b-form-group>

        <formcombobox style="width:250px" :FormDataType="FormDataType.Olcubirimi" :Value="FormData.Olcubirimi"
          :v="$v.FormData.Olcubirimi" @input="FormData.Olcubirimi = $event" />

        <forminput style="width:250px" :FormDataType="FormDataType.Adet" :Value="FormData.Adet" :v="$v.FormData.Adet"
          @input="FormData.Adet = $event" :min="0"
              :step="0.01"/>

        <forminput :FormDataType="FormDataType.Aciklama" :Value="FormData.Aciklama" :v="$v.FormData.Aciklama"
          @input="FormData.Aciklama = $event" />


        <button class="btn btn-primary" type="submit">
          {{ $t("satdosyamalzeme.MalzemeEkle.Button") }}
        </button>
      </Form>

      <yenimalzeme :Id="DataUpdate" :AddEdit="'Add'" @TableUpdate="Get(), malzemeleri_yukle(FormDataMalzeme.Grupid)" />

    </b-modal>
  </Loader>
</template>
